// Existing quiz form JavaScript
document.getElementById('quiz-form').addEventListener('submit', function(event) {
    event.preventDefault();

    var price = document.getElementById('price').value;
    var type = document.getElementById('type').value;
    var grip = document.getElementById('grip').value;
    var durability = document.getElementById('durability').value;
    var mat = document.getElementById('mat').value;

    var products = [
        {name: "Squiddy", price: "0-50", type: "beginner", grip: 4, durability: 4, url: "https://www.squidindustries.co/collections/squiddy-collection",img: "https://cdn.shopify.com/s/files/1/2366/5515/products/Squiddy.png?v=1682977031"},
        {name: "Squiddy-AL", price: "50-100", type: "beginner", grip: 5, durability: 4, url: "https://www.squidindustries.co/collections/squiddy-al",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Squiddy-AL.jpg?v=1728422767"},
        {name: "Squiddy-WH", price: "50-100", type: "beginner", grip: 5, durability: 5, url: "https://www.squidindustries.co/products/squiddy-wh",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Squiddy-WH.png?v=1728422863"},
        {name: "Mako V5", price: "100-150", type: "intermediate", grip: 6, durability: 6, url: "https://www.squidindustries.co/collections/mako",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Dual_Tone_Mako_V5_Red_and_Black.jpg?v=1724776623"},
        {name: "Triton V2", price: "100-150", type: "intermediate", grip: 5, durability: 5, url: "https://www.squidindustries.co/collections/triton",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Triton_V2_Collection.jpg?v=1728423207"},
        {name: "Squidtrainer", price: "150-200", type: "advance", grip: 8, durability: 5, url: "https://www.squidindustries.co/collections/squidtrainer",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Inked_Pink_Squidtrainer_V4.jpg?v=1714602355"},
        {name: "Swordfish", price: "150-200", type: "advance", grip: 6, durability: 5, url: "https://www.squidindustries.co/collections/the-swordfish-collection",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Red_Black_Silver_Swordfish_ISO.jpg?v=1728423476"},
        {name: "Kraken", price: "200-250", type: "advance", grip: 7, durability: 6, url: "https://www.squidindustries.co/collections/krake-raken",img: "https://cdn.shopify.com/s/files/1/2366/5515/products/KrakeRakenTrainerV2_InkedRed_4472_0058ae54-181f-48d6-8e65-6164fd9079fa.jpg?v=1678160422"},
        {name: "Nautilus", price: "200-250", type: "advance", grip: 9, durability: 6, url: "https://www.squidindustries.co/collections/nautilus",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Inked_Black_Nautilus_V2.jpg?v=1724867720"},
        {name: "Titanium Kraken", price: "250~", type: "competition", grip: 7, durability: 9, url: "https://www.squidindustries.co/collections/titanium-krake-raken",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Stonewash_Titanium_Krake_Raken_Trainer.jpg?v=1721241208"},
        {name: "Tsunami", price: "250~", type: "competition", grip: 10, durability: 10, url: "https://www.squidindustries.co/collections/the-tsunami-trainer-collection",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Satin_Tsunami_Trainer.jpg?v=1726079385"},
        {name: "Madko", price: "250~", type: "competition", grip: 8, durability: 9, url: "https://www.squidindustries.co/collections/the-madko-collection",img: "https://cdn.shopify.com/s/files/1/2366/5515/files/Stonewash_Madko.jpg?v=1722874478"}
    ];

     // Filter products based on price (budget)
    var filteredProducts = products.filter(function(product) {
        return product.price === price;
    });

    var bestMatch = null;
    var bestMatchCount = 0;

    // Find the best match considering type, grip, and durability
    filteredProducts.forEach(function(product) {
        var matchCount = 0;

        if (type === product.type) matchCount++;
        if (parseInt(grip.split('-')[0]) <= product.grip && product.grip <= parseInt(grip.split('-')[1])) matchCount++;
        if (parseInt(durability.split('-')[0]) <= product.durability && product.durability <= parseInt(durability.split('-')[1])) matchCount++;

        if (matchCount > bestMatchCount) {
            bestMatch = product;
            bestMatchCount = matchCount;
        }
    });


    var output = '';
    var matLink = 'https://www.squidindustries.co/products/flipping-mat'; 

    if (bestMatch) {
        output = `<div>
                    <p>We recommend: <a href="${bestMatch.url}" target="_blank">${bestMatch.name}</a></p>
                    <img src="${bestMatch.img}" alt="${bestMatch.name} preview" class="product-preview">
                  </div>`;
        if (mat === 'no') {
            output += ` and a <a href="${matLink}" target="_blank">Flipping Mat</a>`;
        }
    } else {
        // Handle no match scenario
        if (filteredProducts.length > 0) {
            bestMatch = filteredProducts[0];
            output = `<div>
                        <p>No perfect match found, but you may like: <a href="${bestMatch.url}" target="_blank">${bestMatch.name}</a></p>
                        <img src="${bestMatch.img}" alt="${bestMatch.name} preview" class="product-preview">
                      </div>`;
        } else {
            output = 'No product found that fits your criteria.';
        }
    }

    document.getElementById('recommendation').innerHTML = output;
});